export default function MinusIcon({ width = "32", height = "32" }: { width?: string, height?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill="none"
            aria-hidden="true"
            color="#08F"
            viewBox="-1 -1 27 27"
            className="cursor-pointer"
        >
            <path
                fill="#FFF"
                d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z"
            ></path>
            <path
                fill="#08F"
                d="M16.667 12.667H7.334v-1.333h9.333v1.333zM12 23C5.925 23 1 18.075 1 12h-2c0 7.18 5.82 13 13 13v-2zm11-11c0 6.075-4.925 11-11 11v2c7.18 0 13-5.82 13-13h-2zM12 1c6.075 0 11 4.925 11 11h2c0-7.18-5.82-13-13-13v2zm0-2C4.82-1-1 4.82-1 12h2C1 5.925 5.925 1 12 1v-2z"
            ></path>
        </svg>
    )
}